import { IAction } from '~/src/store';

import { EContactAlertActions } from './index';

export interface IAlertContact {
    value: string,
    id?: number,
}

export type TSetContact = IAction<EContactAlertActions.SET_CONTACT, IAlertContact>;

const setContact = (contact: IAlertContact): TSetContact => ({
    type: EContactAlertActions.SET_CONTACT,
    payload: contact,
});

export default setContact;
